/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockMinus = createReactComponent("outline", "clock-minus", "IconClockMinus", [["path", { "d": "M20.477 15.022a9 9 0 1 0 -7.998 5.965", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

export { IconClockMinus as default };
//# sourceMappingURL=IconClockMinus.mjs.map
